import { IsNotEmpty, IsString, MinLength, MaxLength, IsNumber, IsBoolean } from 'class-validator';

export class ProfileChangeTwofactorStatusDTO {

    @IsNotEmpty()
    @IsString()
    @MinLength(8)
    @MaxLength(75)
    password: string;

    @IsNotEmpty()
    @IsNumber()
    otp: number;

    @IsNotEmpty()
    @IsBoolean()
    status: boolean;

}
